var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { Map, Markers } from "../../Map";
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";
import {
  getAndSelectDocument,
  selectDocuments,
  unselectAllDocuments } from "../actions/libraryActions";

import { SearchBar } from "./SearchBar";
import { t } from "../../I18N";

class MapViewComponent extends Component {
  constructor(props) {
    super(props);
    this.clickOnMarker = this.clickOnMarker.bind(this);
    this.clickOnCluster = this.clickOnCluster.bind(this);
  }

  clickOnMarker(marker) {
    this.props.getAndSelectDocument(marker.properties.entity.sharedId);
  }

  clickOnCluster(cluster) {
    this.props.unselectAllDocuments();
    this.props.selectDocuments(cluster.map((m) => m.properties.entity));
  }

  render() {
    const { storeKey, markers } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "library-map main-wrapper", style: { width: '100%', height: '100%' } }, void 0, /*#__PURE__*/
      _jsx("div", { className: "search-list" }, void 0, /*#__PURE__*/
      _jsx(SearchBar, { storeKey: storeKey })
      ), /*#__PURE__*/
      _jsx("div", { className: "documents-counter" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, markers.get('totalRows')), " ", t('System', 'documents')
      )
      ), /*#__PURE__*/
      _jsx(Markers, { entities: markers.get('rows') }, void 0,
      (processedMarkers) => /*#__PURE__*/
      React.createElement(Map, {
        ref: (ref) => {
          // eslint-disable-next-line react/no-unused-class-component-methods
          this.map = ref;
        },
        markers: processedMarkers,
        clickOnMarker: this.clickOnMarker,
        clickOnCluster: this.clickOnCluster,
        renderPopupInfo: true,
        cluster: true }
      )

      )
      ));

  }
}









function mapStateToProps(state, props) {
  return {
    markers: state[props.storeKey].markers
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    { getAndSelectDocument, selectDocuments, unselectAllDocuments },
    wrapDispatch(dispatch, props.storeKey)
  );
}

const MapView = connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  MapViewComponent
);

export { MapViewComponent, MapView };